import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/services/data-service/data.service';
import { StoreService } from '../shared/services/store-service/store.service';
import { Client } from '../shared/models/client';
import { Entitlement } from '../shared/models/entitlement';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: [],
})
export class ClientComponent implements OnInit {
  searchString: string = '';
  loading: boolean;
  deleteError: boolean;
  deleteLoading: boolean;
  currentClientText: string;
  currentClient: Client;
  showConfirmPopup: boolean;
  deletedClient: Client[];

  constructor(
    private dataService: DataService,
    public storeService: StoreService,
  ) {
    this.loading = true;
    this.deleteError = false;
    this.deleteLoading = false;
    this.currentClientText = '';
    this.showConfirmPopup = false;
    this.deletedClient = [];
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.dataService.initClients();
    } finally {
      this.loading = false;
    }
  }

  clearSearch() {
    this.searchString = '';
  }

  async checkingDeleteClient(client: Client) {
    this.showConfirmPopup = false;
    this.deleteError = false;
    this.deleteLoading = true;
    this.currentClientText = '"' + client.name + ' | ' + client.id + '"';
    if (await this.checkDeleteAble(client)) {
      this.openPopUp(client);
    } else {
      this.deleteError = true;
    }
  }

  async deleteClient(client: Client) {
    // Delete Client
    this.closePopUp();
    this.deletedClient.push(client);
    await this.dataService.deleteClient(client);
  }

  closeError() {
    this.deleteError = false;
  }

  openPopUp(client: Client) {
    this.currentClient = client;
    this.showConfirmPopup = true;
  }
  closePopUp() {
    this.showConfirmPopup = false;
  }

  showDeletedBadge(client: Client) {
    var searchIndex = this.deletedClient.indexOf(client);
    if (searchIndex > -1) {
      return true;
    } else {
      return false;
    }
  }

  async checkDeleteAble(client: Client): Promise<boolean> {
    var entitlementMapping: Entitlement[];
    try {
      entitlementMapping = await this.dataService.getEntitlementByClientId(
        client.id,
      );
      if (entitlementMapping.length == 0) {
        this.deleteLoading = false;
        return true;
      } else {
        this.deleteLoading = false;
        return false;
      }
    } catch (e) {
      this.deleteLoading = false;
      return true;
    }
  }
}
